module.exports = __webpack_public_path__ + "static/media/Vouchers.cc94c14d.jpg";